import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=46c225cd&scoped=true&"
import script from "./DashboardView.vue?vue&type=script&lang=ts&"
export * from "./DashboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c225cd",
  null
  
)

export default component.exports